import React, { useState, useEffect } from 'react';
import AresNavBar from './../Layout/NavBar/NavBar';
import { useHistory } from 'react-router-dom'
import SideBar from '../Layout/SideBar/SideBar';
import moment from 'moment';

import './index.css'

import { Col, Row, Spinner } from 'react-bootstrap';
import client from "../../services/Api";
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import { useAuth } from '../../providers/auth';
import { ModalManager } from 'react-dynamic-modal/lib/Modal';
import EditBeaconModal from '../AccountDevices/EditBeaconModal';

function AccountDevice() {

  const [loading, setLoading] = useState(true)
  const [tableData, setTableData] = useState(null)
  const [tableKey, setTableKey] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const history = useHistory();
  const { user } = useAuth()

  //datatable config
  const columns = [
    {
      name: 'Nome',
      selector: 'name',
      sortable: false,
      width: '15%',
    },
    {
      name: 'Número de série',
      format: row => row.model != null && row.model != undefined && row.model != '' ? row.model : '--',
      selector: 'model',
      sortable: false,
      width: '12%',
    },
    {
      name: 'Endereço Mac',
      selector: 'mac',
      sortable: false,
      width: '12%',
    },
    {
      name: 'Último sincronismo',
      selector: 'lastSyncDate',
      format: row => row.lastSyncDate != null ? moment.utc(row.lastSyncDate).local().format('DD/MM/YYYY HH:mm:ss') : '--',
      sortable: false,
      width: '12%',
    },
    {
      name: 'Qtd de registros',
      sortable: false,
      width: '12%',
      cell: (row) =>
        <Row>
          <Col>
            {row.logsLoading ? <p style={{ marginTop: '15px' }}>Carregando...</p> : row.logsCount != null ? row.logsCount : <a href="#" style={{ textAlign: 'center' }} onClick={() => { getHistoricCount(row) }}>Clique para ver</a>}
          </Col>
        </Row>
    },
    {
      name: 'Data de criação',
      format: row => moment.utc(row.created_at).local().format('DD/MM/YYYY HH:mm:ss'),
      selector: 'created_at',
      sortable: true,
      width: '12%',
    },
    {
      name: 'Ações',
      cell: (row) =>
        <Row>
          {user.profile._id != '6089aebd882b6b8c415c4de5' && user.profile._id != '6086f578b3f7ce0def82f243' ? <Col>
            <div className="actions">
              <button className="add-beacon edit-beacon" onClick={() =>
                openEditBeaconModal(row.mac, row.name)
              }>
                Alterar Nome
                  </button>
            </div>
          </Col> : null}

          <Col>
            <button className="edit-beacon" onClick={() =>
              history.push(`/device-history/${row.mac}/${row._id}`, { name: row.name, model: row.model })
            }>
              Histórico
            </button>
          </Col>
        </Row>
      ,
      width: '20%',
    },
  ];

  useEffect(() => {
    init()
    setLoading(true)
  }, []);

  function openEditBeaconModal(macid, beaconName) {
    ModalManager.open(<EditBeaconModal mac={macid} beaconName={beaconName} />)
  }

  async function init() {
    const response = await getBeacons();
    if (response !== null) {
      const data = response.data;
      setTableData({
        data,
        columns
      })
    }
    setLoading(false);
  }

  async function getBeacons() {
    try {
      if (user.profile._id == "60846a923c0c98d2837f2e42") {
        const response = await client.get("/api/beacon-device/all");
        return response;
      } else {
        const response = await client.get(`/api/devices-by-user/${user.id}`);
        console.log(response)
        return response;
      }
    } catch (e) {
      console.log(e);
    }
    return null;
  }

  const getHistoricCount = async (device) => {
    try {
      device.logsLoading = true;
      setTableKey((oldKey) => {
        oldKey++
        return oldKey
      });
      const response = await client.get(`/api/beacon-device/${device.mac}/historic-count`)
      device.logsLoading = false;
      device.logsCount = response.data.count;
      setTableData((oldData) => {
        oldData.data.map((item) => {
          if (item.mac == device.mac)
            item = device;
          return item;
        })
        return oldData;
      })
      setTableKey((oldKey) => {
        oldKey++
        return oldKey
      });
    } catch (e) {
      console.log(e);
    }
  }

  function renderLoading() {
    return (
      <div className="center-page">
        <Spinner animation="border" />
      </div>
    )
  }

  return (
    <div className="Beacons sidenav-margin">
      <AresNavBar />
      <SideBar />
      <div className="content">
        <div className="container-header">
          <h1>Meus Dispositivos</h1>
        </div>
        {loading ?
          renderLoading()
          :
          <div>
            <div className="beacon-table">
              {table()}
            </div>
          </div>
        }
      </div>
    </div>
  );

  function table() {
    return (
      <DataTableExtensions
        {...tableData}
        filterPlaceholder="Pesquisar dispositivos"
        print={false}>
        <DataTable
          key={tableKey}
          noDataComponent={
            <span>Nada encontrado...</span>
          }
          pagination={true}
          paginationDefaultPage={page}
          paginationPerPage={rowsPerPage}
          onChangePage={(page) => setPage(page)}
          paginationComponentOptions={{ noRowsPerPage: true }}
          onChangeRowsPerPage={(rowsPerPage, page) => {
            setPage(page);
            setRowsPerPage(rowsPerPage)
          }}
        />
      </DataTableExtensions>
    );
  }
}

export default AccountDevice;
